'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppController = function AppController($rcAlerts, NAV_CONTENT, FOOTER_CONTENT) {
  'ngInject';

  (0, _classCallCheck3.default)(this, AppController);
  this.alerts = $rcAlerts.alerts;
  this.navContent = NAV_CONTENT;
  this.footerContent = FOOTER_CONTENT;
};

exports.default = AppController;
;


// WEBPACK FOOTER //
// ./src/app/app.controller.js